export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-mobile-e1c5d71ab387350edb73a7e3d6c479b8.svg";